<template>
  <div class="row" v-if="isIntegrationActive">
    <div class="col">
      <div class="input-group ">
        <input ref="searchPmsInput" v-model="term" @keyup.enter="search" type="text" class="form-control text-center border-0" placeholder="Patient Search. Enter patient name, email or phone" />
        <div class="input-group-append">
          <button @click="search" class="btn btn-primary" :disabled="isSearching">
            <font-awesome-icon icon="spinner-third" spin v-if="isSearching" />
            <span v-else>Search</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import { IntegrationApi, PatientApi } from '@/services'
export default {
  props: ['term'],
  data() {
    return {
      isSearching: false,
      results: [],
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isIntegrationActive']),
  },
  async mounted() {},
  methods: {
    async search() {
      this.isSearching = true
      try {
        let response = await PatientApi.get(
          'search-pms/' + encodeURIComponent(this.term)
        )
        this.results = response
      } catch (err) {
        this.error = (err && err.message) || 'Failed to search'
      }
      this.isSearching = false
    },
  },
}
</script>

<style scoped>
.appointment-card {
  border: 1px solid #1cacda;
  height: 100%;
  cursor: pointer;
  position: relative;
}
.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff60;
}
</style>
